import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { buscarCep, extract } from '../../util/util';
import ReactSelect from '../../components/ReactSelect';
import { toast } from 'react-toastify';
import { FinField, FinInput } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';

export default function CadastroLocal({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();

    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (!resposta.erro) {
                setDados({
                    ...dadosAtuais,
                    bairro: resposta.bairro ?? dadosAtuais.bairro,
                    endereco: resposta.logradouro ?? dadosAtuais.endereco,
                    pais: "30",
                    nomePais: "Brasil",
                    municipio: resposta.ibge ?? dadosAtuais.municipio,
                    nomeMunicipio: resposta.localidade && resposta.uf
                        ? `${resposta.localidade}-${resposta.uf}`
                        : (resposta.localidade ?? dadosAtuais.nomeMunicipio)
                });
            }
        });
    };

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/local/' + id,
                token: token,
            }).then(response => {
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: ['pais', 'municipio']
                });
                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            setDados({ ...dados, situacaoRegistro: 'ativo', pais: '30', nomePais: 'Brasil' });
            setIsLoading(false);
        }
    };

    const salvar = () => {
        if (isSubmitting) return;

        if (!dados.nome || dados.nome.trim() === '') {
            toast.error('É necessário preencher o Nome do local');
            return;
        }

        setIsSubmitting(true);

        if (id) {
            api({
                method: 'put',
                action: '/local/' + id,
                token: token,
                data: dados,
            }).then(() => {
                toast.success('Local atualizado com sucesso!');
                history.push("/local");
            }).catch(error => {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? "Erro desconhecido"));
            }).finally(() => { setIsSubmitting(false); });
        } else {
            api({
                method: 'post',
                action: '/local',
                token: token,
                data: dados,
            }).then(() => {
                toast.success('Local cadastrado com sucesso!');
                history.push("/local");
            }).catch(error => {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? "Erro desconhecido"));
            }).finally(() => { setIsSubmitting(false); });
        }
    };

    useEffect(() => {
        document.querySelector("#nome")?.focus();
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Local</h1>
                    </div>
                </div>

                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Situação">
                                <ReactSelect
                                    value={{ value: dados.situacaoRegistro, label: dados.situacaoRegistro === 'ativo' ? 'Ativo' : 'Inativo' }}
                                    onChange={e => setDados({ ...dados, situacaoRegistro: e.value })}
                                    options={[
                                        { value: 'ativo', label: 'Ativo' },
                                        { value: 'inativo', label: 'Inativo' },
                                    ]}
                                />
                            </FinField>
                            <FinField grow label="Nome" required>
                                <FinInput
                                    type="text"
                                    id="nome"
                                    value={dados.nome || ''}
                                    onChange={e => setDados({ ...dados, nome: e.target.value })}
                                    required
                                />
                            </FinField>
                        </div>
                    </div>

                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                            <h2 className="fin-pp__cphead-title">Endereço</h2>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField grow label="Endereço">
                                <FinInput
                                    type="text"
                                    id="endereco"
                                    value={dados.endereco || ''}
                                    onChange={e => setDados({ ...dados, endereco: e.target.value })}
                                />
                            </FinField>
                            <FinField label="CEP">
                                <FinInput
                                    type="text"
                                    id="enderecocep"
                                    value={dados.enderecocep || ''}
                                    onChange={(e) => {
                                        const cepValue = e.target.value;
                                        const dadosAtualizados = { ...dados, enderecocep: cepValue };
                                        setDados(dadosAtualizados);
                                        if (cepValue.length === 8) {
                                            preencherCep(cepValue, dadosAtualizados);
                                        }
                                    }}
                                />
                            </FinField>
                            <FinField label="Bairro">
                                <FinInput
                                    type="text"
                                    id="bairro"
                                    value={dados.bairro || ''}
                                    onChange={e => setDados({ ...dados, bairro: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Cidade">
                                <ReactSelect
                                    value={{ value: dados.municipio, label: dados.nomeMunicipio }}
                                    onChange={e => setDados({ ...dados, municipio: e.value, nomeMunicipio: e.label })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/municipio',
                                            token: token,
                                            params: { nome: input }
                                        }).then(response => {
                                            return response.data.data.map(r => ({ value: r.id, label: r.nome + "-" + r.uf }));
                                        }).catch(() => {});
                                    }}
                                />
                            </FinField>
                            <FinField label="Município Exterior">
                                <FinInput
                                    type="text"
                                    id="municipioExterior"
                                    value={dados.municipioExterior || ''}
                                    onChange={e => setDados({ ...dados, municipioExterior: e.target.value })}
                                />
                            </FinField>
                            <FinField label="País">
                                <ReactSelect
                                    value={{ value: dados.pais, label: dados.nomePais }}
                                    onChange={e => setDados({ ...dados, pais: e.value, nomePais: e.label })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/pais',
                                            token: token,
                                            params: { nome: input }
                                        }).then(response => {
                                            return response.data.data.map(r => ({ value: r.id, label: r.nome }));
                                        }).catch(() => {});
                                    }}
                                />
                            </FinField>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Salvando...</>
                                : <><FaSave size={16} /> Salvar</>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
